// extracted by mini-css-extract-plugin
export default {"main":"App_main__R9T0n","header":"App_header__yK1Av","slideDown":"App_slideDown__Dwniy","content":"App_content__YA1CJ","footer":"App_footer__rM18z"};